import {
  DetailsContainer,
  DetailsTitle,
  DetailItemContainer,
  DetailLabel,
  DetailValue,
  SectionTitle,
} from './styles';
import { Box, CircularProgress, Stack } from '@mui/material';
import { usePoiTemplateFields } from '../../../../hooks/usePoiTemplateFields';
import { PointOfInterest } from '@/__generated__/graphql';
import { Suspense } from 'react';
import { BlisterMeasurementSection } from './BlisterMeasurementSection';
import { BLISTER_TYPE, PIT_TYPE } from '@/constants';
import { EmptyPlaceholder } from '../styles';

interface DetailsSidebarProps {
  data: PointOfInterest;
}

export const DetailsSidebar = ({ data }: DetailsSidebarProps) => {
  const { templateFieldsWithValues } = usePoiTemplateFields({ data });

  return (
    <DetailsContainer>
      <DetailsTitle variant="h6">Details</DetailsTitle>

      <Stack spacing={1}>
        {templateFieldsWithValues.map((field, index) => (
          <DetailItemContainer key={index}>
            <DetailLabel>{field.label}</DetailLabel>
            <DetailValue>{field.value}</DetailValue>
          </DetailItemContainer>
        ))}
      </Stack>

      {(data?.type === BLISTER_TYPE || data?.type === PIT_TYPE) && (
        <Box mt={3}>
          <SectionTitle variant="h6">Blister Profile</SectionTitle>
          <Suspense
            fallback={
              <EmptyPlaceholder sx={{ height: '18rem', width: '100%' }}>
                <CircularProgress size={40} />
              </EmptyPlaceholder>
            }
          >
            <BlisterMeasurementSection data={data} />
          </Suspense>
        </Box>
      )}
    </DetailsContainer>
  );
};
